
export const requestedMenuAll = {
    dashboardKey: "DASHBOARD",
    companyMasterKey: "COMPANY_MASTER",
    glMasterKey: "GL_MASTER",
    accommodationTabMasterKey: "ACCOMMODATION_TAB_MASTER",
    allowanceTabMasterKey: "ALLOWANCE_TAB_MASTER",
    appTrackReportKey: "APP_TRACK_REPORT",
    energyPriceTabMasterKey: "ENERGY_PRICE_TAB_MASTER",
    energyTypeTabMasterKey: "ENERGY_TYPE_TAB_MASTER",
    bankMasterKey: "BANK_MASTER",
    customerMasterKey: "CUSTOMER_MASTER",
    primaryCustTabMasterKey: "PRIMARYCUSTOMER_TAB_MASTER",
    secondCustTabMasterKey: "SECONDCUSTOMER_TAB_MASTER",
    planApplicableMasterKey: "PLAN_APPLICABLE_MASTER",
    competitorOffersKey: "COMPETITOR_PRODUCTS_MASTER",
    ifdCompetitorMasterKey: "IFD_COMPETITOR_MASTER",
    fdCompetitorMasterKey: "FD_COMPETITOR_MASTER",
    employeeMasterKey: "EMPLOYEE_MASTER",
    userMasterKey: "USER_MASTER",
    divisionMasterKey: "DIVISION_MASTER",
    plantMasterKey: "PLANT_MASTER",
    planValidationKey: "PLAN_VALIDATION",
    planValidationManagerKey: "PLAN_VALIDATION_MANAGER",
    planDeviationBOKey: "PLAN_DEVIATION_BACKOFFICE",
    planDeviationManagerKey: "PLAN_DEVIATION_MANAGER",
    approvalFoodsMasterKey: "APPROVAL_PLAN_FOODS",
    approvalClaimBOKey: "CLAIM_VALIDATION_BACKOFFICE",
    claimApprovalLevelControlKey: "CLAIM_APPROVAL_LEVEL_CONTROL",
    regularApprovalClaimRMKey: "REGULAR_CLAIM_VALIDATION_RM",
    regularApprovalClaimDMKey: "REGULAR_CLAIM_VALIDATION_DM",
    regularApprovalClaimHRKey: "REGULAR_CLAIM_VALIDATION_HR",
    regularApprovalClaimAEKey: "REGULAR_CLAIM_VALIDATION_AE",
    regularApprovalClaimAMKey: "REGULAR_CLAIM_VALIDATION_AM",
    approvalClaimExecKey: "CLAIM_VALIDATION_EXECUTIVE",
    prospectValidationMasterKey: "PROSPECT_VALIDATION",
    shiftMasterKey: "SHIFT_MASTER",
    outletMasterKey: "OUTLET_MASTER",
    prospectMasterKey: "PROSPECT_MASTER",
    venueMasterKey: "VENUE_MASTER",
    locationMasterKey: "LOCATION_MASTER",
    countryTabMasterKey: "COUNTRY_TAB_MASTER",
    stateTabMasterKey: "STATE_TAB_MASTER",
    districtTabMasterKey: "DISTRICT_TAB_MASTER",
    cityTabMasterKey: "CITY_TAB_MASTER",
    areaTabMasterKey: "AREA_TAB_MASTER",
    roleMasterKey: "ROLE_MASTER",
    departmentTabMasterKey: "DEPARTMENT_TAB_MASTER",
    designationTabMasterKey: "DESIGNATION_TAB_MASTER",
    gradeTabMasterKey: "GRADE_TAB_MASTER",
    gradeListTabMasterKey: "GRADE_LIST_TAB_MASTER",
    roleTabMasterKey: "ROLE_TAB_MASTER",
    menuMasterKey: "MENU_MASTER",
    menuTabMasterKey: "MENU_TAB_MASTER",
    menuListTabMasterKey: "MENULIST_TAB_MASTER",
    menuAccessTabMasterKey: "MENU_ACCESS_TAB_MASTER",
    productMasterKey: "PRODUCT_MASTER",
    brandTabMasterKey: "BRAND_TAB_MASTER",
    categoryTabMasterKey: "CATEGORY_TAB_MASTER",
    productTabMasterKey: "PRODUCT_TAB_MASTER",
    materialTabMasterKey: "MATERIAL_TAB_MASTER",
    claimMasterKey: "CLAIM_MASTER",
    dropdownMasterKey: "DROPDOWN_MASTER",
    dropdownTabMasterKey: "DROPDOWN_TAB_MASTER",
    dropdownListTabMasterKey: "DROPDOWN_LIST_TAB_MASTER",
    zoneMasterKey: "ZONE_MASTER",
    zoneTabMasterKey: "ZONE_TAB_MASTER",
    subZoneTabMasterKey: "SUBZONE_TAB_MASTER",
    approvalMasterKey: "APPROVAL_MASTER",
    planCreationKey: "PLAN_CREATION",
    claimCreationKey: "CLAIM_CREATION",
    attendanceReportKey: "ATTENDANCE_REPORT",
    userReportKey: "USER_REPORT",
    travelReportKey: "TRAVEL_REPORT",
    ifoodsPlanReportKey: "PLAN_REPORT",
    outletVisitReportKey: "OUTLET_VISIT_REPORT",
    primaryCustomerVisitReportKey: "PRIMARY_CUSTOMER_VISIT_REPORT",
    secondaryOutletVisitReportKey: "SECONDARY_OUTLET_VISIT_REPORT",
    prospectReportKey: "PROSPECT_REPORT",
    primeCustReportKey: "PRIMARY_CUSTOMER_REPORT",
    competitorReportKey: "COMPETITOR_REPORT",
    secondCustReportKey: "SECONDARY_CUSTOMER_REPORT",
    mapViewReportKey: "MAP_VIEW",
    planDeviationReportKey: "PLAN_DEVIATION_REPORT",
    claimDetailsReportKey: "CLAIM_DETAILS_REPORT",
    claimExpenseReportKey: "CLAIM_EXPENSE_REPORT",
    travelClaimReportKey: "TRAVEL_CLAIM_REPORT",
    secondaryOrderReportKey: "SECONDARY_ORDER_REPORT",
    pjpReportKey: "PJP_REPORT",
    primaryOrderReportKey: "PRIMARY_ORDER_REPORT",
    venueMappingReportKey: "VENUE_MAPPING_REPORT",
    marketPromotionReportKey: "MARKET_PROMOTION_REPORT",
    settingsKey: "SETTINGS",
    notificationSettingsTabKey: "NOTIFICATION_SETTINGS_TAB",
    commonNotificationKey: "COMMON_NOTIFICATION",
    calendarEventKey: "CALENDAR_EVENT",
    primeMatMappingKey: "PRIMARY_MATERIAL_MAPPING",
    activeUsersDashboardKey: "ACTIVE_USERS_DASHBOARD",
    ifoodsDashboardKey: "IFOODS_DASHBOARD",
    eventMasterKey: "EVENT_MASTER",
    approvalClaimManagerKey: "CLAIM_VALIDATION_MANAGER",
    claimFrequencyMasterKey: "CLAIM_FREQUENCY_MASTER",
    claimFrequencyTypeKey: "CLAIM_FREQUENCY_TYPE",
    approvalSecCustomerKey: "APPROVAL_SECONDARY_CUSTOMER",
    claimLocationCategoryKey: "CLAIM_LOCATION_CATEGORY",
    expenseLimitTabMasterKey: "EXPENSE_LIMIT_TAB_MASTER",
    schemesCategoryKey: "SCHEMES_CATEGORY",
    targetKey: "TARGET_VS_ACTUAL",
    claimStatusLogKey: "CLAIM_STATUS_LOG",
    claimLogKey: "CLAIM_LOG",
    claimExpenseLogKey: "CLAIM_EXPENSE_LOG",
    dashboardSliderKey: "DASHBOARD_SLIDER",

    //===============Sooji QR Bag ======================================//

    newBagRequestKey: "NEW_BAG_REQUEST",
    bagRequestKey: "BAG_REQUEST",
    bagIssueKey: "BAG_ISSUE",
    storeNewBagRequestKey: "STORE_NEW_BAG_REQUEST",
    bagReportKey: "BAG_REPORT",
    fillBagKey: "FILL_BAG",
    qcReleaseKey: "QC_RELEASE",
    qcReleaseExceededKey: "QC_RELEASE_EXCEEDED",
    roastingProcessKey: "ROASTING_PROCESS",
    roastingProcessExceededKey: "ROASTING_PROCESS_EXCEEDED",
    fumigationProcessKey: "FUMIGATION_PROCESS",
    fumigationProcessExceededKey: "FUMIGATION_PROCESS_EXCEEDED",
    qrTransReportKey: "QR_TRANSACTION_REPORT",
    qrcodedBagStatusKey: "QR_CODED_BAG_STATUS_REPORT",

    /* ============== Scheme Dasboard Part Start ============== */

    schemeOperationsKey: "SCHEME_OPERATIONS",
    schemeCreationKey: "SCHEME_CREATIONS",
    schemeCreationApprovalKey: "SCHEME_CREATION_APPROVAL",
    schemeCreationApprovalCHKey: "SCHEME_CREATION_APPROVAL_CH",
    schemeCreationApprovalBHKey: "SCHEME_CREATION_APPROVAL_BH",
    schemePlanningOperationsKey: "SCHEME_PLANNING_OPERATIONS",
    schemeStatusMasterKey: "SCHEME_STATUS_MASTER",
    schemeNonEligibleApprovalMasterKey: "SCHEME_NON_ELIGIBLE_APPROVAL",

    schemeGMApprovalKey: "SCHEME_GM_APPROVAL",
    schemeCHapprovalKey: "SCHEME_CH_APPROVAL",
    schemeAdminEditKey: "SCHEME_ADMIN_EDIT",
    schemeBHapprovalKey: "SCHEME_BH_APPROVAL",
    schemeAHcreditnoteApprovalKey: "SCHEME_AH_CREDIT_NOTE_APPROVAL",
    schemeCreditnoteReportKey: "SCHEME_CREDIT_NOTE_REPORT",
    schemeCustomerWiseReportKey: "SCHEME_CUSTOMER_WISE_REPORT",
    schemeCostCenterActualReportKey: "SCHEME_COST_CENTER_ACTUAL_REPORT",
    schemeRejectedCustomerReportKey: "SCHEME_REJECTED_CUSTOMER_REPORT",

    schemeCostCenterMasterKey: "SCHEME_COST_CENTER_MASTER",
    schemeProductCostCenterMappingKey: "SCHEME_PRODUCT_COST_CENTER_MAPPING",

    /* ============== Scheme Dasboard Part End ============== */

    /* ============== Pest Control Module ============== */
    pestControlKey: "PEST_CONTROL",
    pestControlDailyEntryKey: "PEST_CONTROL_DAILY_ENTRY",
    pestControlReportKey: "PEST_CONTROL_REPORT",
    rodentBoxLocationMasterKey: "PEST_CONTROL_RODENT_BOX_LOCATION",
    locationTrapStationMappingKey: "PEST_CONTROL_LOCATION_TRAP_STATION_MAPPING",
    rodentQRCodeMappingKey: "PEST_CONTROL_RODENT_QR_CODE_MAPPING",
    rodentQRCodeKey: "PEST_CONTROL_RODENT_QR_CODE",
}

export const requestedFeaturesAll = {
    createKey:  "CREATE",
    readKey: "READ",
    updateKey: "UPDATE",
    deleteKey: "DELETE",
};
